// src/hooks/useStockAggregator.js
import { useState, useEffect, useCallback, useRef } from 'react';
import { db } from '../firebaseConfig';
import { collection, onSnapshot } from 'firebase/firestore';

const CURRENT_STOCK_COLLECTION = 'current-stock';

export const useStockAggregator = () => {
    const [stockTotals, setStockTotals] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [lastUpdate, setLastUpdate] = useState(null);

    useEffect(() => {
        setIsLoading(true);

        // ESCUTA EM TEMPO REAL A COLEÇÃO DE ESTOQUE ATUAL
        const q = collection(db, CURRENT_STOCK_COLLECTION);

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const totals = {};

            snapshot.docs.forEach(doc => {
                const data = doc.data();
                // Identifica o material (suporta diferentes nomes de campo para flexibilidade)
                const materialId = data.rawMaterialId || data.materialId || data.itemId;
                const quantity = parseFloat(data.quantity) || 0;

                if (materialId && quantity > 0) {
                    // Soma as quantidades (caso haja múltiplos lotes do mesmo material)
                    totals[materialId] = (totals[materialId] || 0) + quantity;
                }
            });

            setStockTotals(totals);
            setLastUpdate(new Date()); // Agora o "Last Updated" será sempre "Agora mesmo"
            setIsLoading(false);
        }, (error) => {
            console.error("Erro no listener de estoque:", error);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, []);

    // Helpers para facilitar o uso na ProductionOrderPage
    const getStockForMaterial = useCallback((materialId) => {
        return stockTotals[materialId] || 0;
    }, [stockTotals]);

    return {
        stockTotals,
        isLoading,
        lastUpdate,
        getStockForMaterial
    };
};